import { webEnv } from "@/environment/environment";

export const constants = {
  siteName: "زیباسی",
  siteShopName: "فروشگاه زیباسی",
  siteNameEn: "Zibasi",
  useLocalBusinessAddress: true,
  localBusiness: {
    name: "فروشگاه زیباسی",
    image: `${webEnv.siteUrl}logo.svg`,
    streetAddress: "محله : حشمتیه - کوچه شهید منصور زارتشت - کوچه خندان - پلاک : 18.0 - طبقه : 2",
    addressLocality: "تهران",
    addressRegion: "تهران",
    postalCode: "1639686415",
    addressCountry: "IR",
    telephone: "+98-21-86125827",
    openingHours: "Mo,Tu,We,Th,Fr 09:00-18:00",
    url: webEnv.siteUrl,
  },
  social: {
    instagram: "https://www.instagram.com/zibasi.ir",
    facebook: "https://www.facebook.com/zibasi.ir",
    twitter: "https://www.x.com/zibasi.ir",
    telegram: "https://t.me/zibasi_ir",
    whatsapp: "https://wa.me/989365563191",
  },
};
